import React, { Fragment } from "react";
import gql from "graphql-tag";
import { Helmet } from "react-helmet";
import pick from "lodash/pick";
import { graphql, compose } from "react-apollo";
import UserEditForm from "./UserEditForm";
import UserQuery from "../queries/User";
import UpdateUserMutation from "../mutations/UpdateUser";
import CenteredLoader from "./CenteredLoader";
import Button from "./Button";

class UserEdit extends React.Component {
  handleSubmit = values => {
    const { history, data: { user } } = this.props;
    this.props
      .updateUser({
        id: user.id,
        input: values
      })
      .then(() => {
        // TODO: Add a flash message
        history.push("/admin/users");
      });
  };

  handleStatusToggle = () => {
    const { data: { user } } = this.props;
    const currentFunc = user.deactivated
      ? this.props.activateUser
      : this.props.deactivateUser;
    return currentFunc(user);
  };

  render() {
    const { data: { loading, user } } = this.props;

    if (loading) return <CenteredLoader />;

    const initialValues = pick(
      user,
      "name",
      "email",
      "phone",
      "role",
      "receiveNotifications"
    );

    return (
      <Fragment>
        <Helmet>
          <title>Edit User</title>
        </Helmet>
        <UserEditForm
          title="Update user"
          buttonText="Update user"
          initialValues={initialValues}
          onSubmit={this.handleSubmit}
          match={this.props.match}
          extraButtons={
            <Button
              variant="danger"
              outline
              type="button"
              style={{ marginLeft: "auto" }}
              onClick={this.handleStatusToggle}
            >
              {user.deactivated ? "Activate" : "Deactivate"} User
            </Button>
          }
        />
      </Fragment>
    );
  }
}

const DEACTIVATE_USER_MUTATION = gql`
  mutation DeactivateUser($id: ID!) {
    deactivateUser(id: $id) {
      id
      deactivated
    }
  }
`;

const ACTIVATE_USER_MUTATION = gql`
  mutation ActivateUser($id: ID!) {
    activateUser(id: $id) {
      id
      deactivated
    }
  }
`;

const enhance = compose(
  graphql(UserQuery, {
    options: ({ match: { params: { userId } } }) => ({
      variables: { id: userId }
    })
  }),
  graphql(UpdateUserMutation, {
    props: ({ mutate }) => ({
      updateUser({ id, input }) {
        return mutate({
          variables: { id, input }
        });
      }
    })
  }),
  graphql(DEACTIVATE_USER_MUTATION, {
    props: ({ mutate }) => ({
      deactivateUser({ id }) {
        return mutate({
          variables: { id },
          refetchQueries: [
            {
              query: UserQuery,
              variables: { id }
            }
          ]
        });
      }
    })
  }),
  graphql(ACTIVATE_USER_MUTATION, {
    props: ({ mutate }) => ({
      activateUser({ id }) {
        return mutate({
          variables: { id },
          refetchQueries: [
            {
              query: UserQuery,
              variables: { id }
            }
          ]
        });
      }
    })
  })
);

export default enhance(UserEdit);



// WEBPACK FOOTER //
// ./src/components/UserEdit.js